import axios from "axios";
import type { ComponentType, FunctionComponent } from "react";
import { useState } from "react";
import { BsBagCheck } from "react-icons/bs";
import { useAppSelector } from "../../hooks/redux.hooks";
import { selectProductsTotalPrice } from "../../store/toolkit/cart/cart.selectors";
import CartItem from "../cart-item/cart-item.component";
import CustomButton from "../custom-button/custom-button.component";
import Loading from "../loading/loading.component";
import {
	CheckoutContainer,
	CheckoutProducts,
	CheckoutTitle,
	CheckoutTotal,
} from "./checkout.styles";

const Checkout: FunctionComponent = () => {
	const BsBagCheckIcon = BsBagCheck as unknown as ComponentType<{
		size?: number;
	}>;
	const { products } = useAppSelector((state) => state.cartReducer);
	const productsTotalPrice = useAppSelector(selectProductsTotalPrice);

	const [isLoading, setIsLoading] = useState(false);

	const handleFinishPurchaseClick = async () => {
		try {
			setIsLoading(true);
			const { data } = await axios.post(
				`${process.env.REACT_APP_API_URL ?? ""}/create-checkout-session`,
				{
					products,
				},
			);
			window.location.href = data.url;
			console.log("Resposta da API:", data.url);
		} catch (error) {
			console.error("Erro ao finalizar compra:", error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<CheckoutContainer>
			{isLoading && <Loading />}
			<CheckoutTitle>Checkout</CheckoutTitle>

			{products.length > 0 ? (
				<>
					<CheckoutProducts>
						{products.map((product) => (
							<CartItem key={product.id} product={product} />
						))}
					</CheckoutProducts>

					<CheckoutTotal>Total: R${productsTotalPrice}</CheckoutTotal>

					<CustomButton
						startIcon={<BsBagCheckIcon />}
						onClick={handleFinishPurchaseClick}
					>
						Finalizar Compra
					</CustomButton>
				</>
			) : (
				<p>Seu carrinho está vazio!</p>
			)}
		</CheckoutContainer>
	);
};

export default Checkout;
